import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Volgers',
  fields: {
    name: 'Naam',
    subscribed: 'Ingeschreven',
    followed: 'Gevolgd',
    phone: 'Telefoon',
    recent_order: 'Recente bestelling',
    total_orders: 'Totaal bestellingen',
    birthday: 'Verjaardag',
    google_review: 'Google Review',
    marketing_subscription_source: 'Geabonneerd via',
    loyalty_points: 'Loyaliteit',
  },
  empty_list: 'Nog geen klanten',
  yes: 'Ja',
  no: 'Nee',
  buttons: {
    import: 'Importeren',
    export: 'Exporteren',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
  labels: {
    followed_since_date: 'Sinds {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
